import { render, staticRenderFns } from "./SizeOptionGroupDialogue.vue?vue&type=template&id=6afbca06&"
import script from "./SizeOptionGroupDialogue.vue?vue&type=script&lang=ts&"
export * from "./SizeOptionGroupDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports